import { Component, Input } from '@angular/core'
import * as d3 from 'd3'
import { Tooltip } from '@dataunveil/ducharts'
import { CommonModule, CurrencyPipe, KeyValue } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'

const timeFormatter = d3.timeFormat('%a, %b %d %Y')

@Component({
  standalone: true,
  imports: [Tooltip, CommonModule, MatIconModule],
  selector: 'app-status-cell-info-dem',
  template: `
    <ng-container *ngIf="data?.details && Object.keys(data.details)?.length">
      <div class="header" *ngIf="header">
        <div class="date">{{ timeFormatter(data.xKey) }}</div>
        <div class="title">Transaction status</div>
      </div>
      <div class="main">
        <div class="file" *ngFor="let file of data.details | keyvalue: byIndex">
          <div class="file-details">
            <div class="status-block"
                [style]="{ 'background-color': data.colorScale($any(file.value).status) }"></div>
            <div class="number">{{ $any(file.value).index }}</div>
            <div class="status">{{ $any(file.value).status }}</div>
          </div>
          <div class="name">{{ file.key }}</div>
          <div class="count">
            <div class="status-count">
            <div class="status"><span><mat-icon class='matIcons' svgIcon="check" ></mat-icon></span>SENT: {{ numbedPipe($any(file.value).count.sent_records) }}
           <span >
                  <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-greenArrow.svg"
                    *ngIf="$any(file.value).sent_records_trend == 'up'" />
                  <span  *ngIf="$any(file.value).sent_records_trend == 'nochange'" style='font-size:28px;color:#1363df;'>-</span>
                  <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-RedArrow.svg"
                    *ngIf="$any(file.value).sent_records_trend == 'down'" />
          </span>
              </div>
          <div class="status"><span><mat-icon class='matIcons' svgIcon="crossdem" ></mat-icon></span>ON HOLD: {{ numbedPipe($any(file.value).count.on_hold) }}
          <span >
                  <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-greenArrow.svg"
                    *ngIf="$any(file.value).on_hold_trend == 'up'" />
                  <span  *ngIf="$any(file.value).on_hold_trend == 'nochange'" style='font-size:28px;color:#1363df;'>-</span>
                  <img src="https://dudevtest-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Vector-RedArrow.svg"
                    *ngIf="$any(file.value).on_hold_trend == 'down'" />
          </span>
        </div>
         <div class="status" *ngIf='$any(file.value).count.time_sent'><span><mat-icon class='matIcons' style="color:yellow" svgIcon="early" ></mat-icon></span>Time Sent: {{ $any(file.value).count.time_sent | date: 'EEE,  MMM dd yyyy hh:mm:ss a' }} {{'EST'}}
         <!-- <div class="status" *ngIf='$any(file.value).count.time_sent'><span><mat-icon class='matIcons' style="color:yellow" svgIcon="early" ></mat-icon></span>Time Sent: {{ $any(file.value).count.time_sent | date: 'EEE, dd MMM yyyy HH:mm:ss EST' }}  -->
      </div>
      <!-- Summary DEM -->
        <div class="status"  *ngIf='$any(file.value).count.early'><span><mat-icon class='matIcons' style="color:#3AC97C" svgIcon="early" ></mat-icon></span>EARLY: {{ $any(file.value).count.early }}</div>
        <div class="status" *ngIf='$any(file.value).count.delay'><span><mat-icon class='matIcons'style="color:red" svgIcon="early" ></mat-icon></span>DELAY: {{ $any(file.value).count.delay }}</div>
       <!--  -->
        <div class="status" *ngIf='$any(file.value).count.earlier_time'><span><mat-icon class='matIcons'style="color:green" svgIcon="early" ></mat-icon></span>AHEAD BY: {{ $any(file.value).count.earlier_time }}</div>
        <div class="status" *ngIf='$any(file.value).count.delay_time'><span><mat-icon class='matIcons'style="color:red" svgIcon="early" ></mat-icon></span>DELAY BY: {{ $any(file.value).count.delay_time }}</div>
        <div class="status" *ngIf='$any(file.value).count.on_time'><span><mat-icon class='matIcons'style="color:#2563EB" svgIcon="early" ></mat-icon></span>ON TIME: {{ $any(file.value).count.on_time }}</div>
         
        </div>
         
    
        </div>
            <!-- <div class="received"><span></span>{{ numbedPipe($any(file.value).count.received) }}
              RECEIVED
            </div>
            <div class="status-count">
              <div>
                <div class="tree-line"></div>
                <div class="success"></div>
                {{ numbedPipe($any(file.value).count.success) }} SUCCESS
              </div>
              <div>
                <div class="tree-line"></div>
                <div class="failed"></div>
                {{ numbedPipe($any(file.value).count.failed) }} FAILURES
              </div>
              <div>
                <div class="tree-line"></div>
                <div class="errors"></div>
                {{ numbedPipe($any(file.value).count.errors) }} ERRORS
              </div>
            </div> -->
          </div>
        </div>
        
    </ng-container>
  `,
  styleUrls: ['./cell-info.scss']
})
export class CellInfo {
  @Input() data: any
  @Input() header: any
  
  byIndex (a: KeyValue<string, any>, b: KeyValue<string, any>): number {
    const f1 = Number(a.value.index)
    const f2 = Number(b.value.index)
    return f1 > f2 ? -1 : f2 > f1 ? 1 : 0
  }

  constructor(private currency: CurrencyPipe) {
  }

  protected readonly timeFormatter = timeFormatter
  Object = Object

  numbedPipe(value: any) {
    return this.currency.transform(value, '', '', '1.0-2')
  }
}